module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table w100\">\n    ")
    ;  Util.each(options, function(option) { 
    ; __append("\n    ")
    ; 
        var attributes = Html.attributes(_.reduce(option.control, function(result, value, field) {
            result['data-control-' + field] = value;
            return result;
        }, {}));
    
    ; __append("\n    <div class=\"section\">\n        <div class=\"title\" style=\"width:30%\">")
    ; __append(escapeFn( option.title ))
    ; __append("</div>\n        <div ")
    ; __append( attributes )
    ; __append(">")
    ; __append(escapeFn( option.value ))
    ; __append("</div>\n    </div>\n    ")
    ;  }) 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}